import * as colocAdminApi from '@/lib/coloc-api/admin';

export const {
  getRentsSummaryHouses,
  getRentsList,
  getRentsListByRentId,
  getRent,
  updateRents,
  getRentTransactions,
  addRentTransaction,
  deleteRentTransaction,
  getTransactionsList,
  getHouseList,
  getOwnerList,
  getRoomList,
  getTenantsForRoom,
  getRentsForContract,
  getRoomsWithTenants,
  linkTransactionWithRent,
  ignoreTransaction,
  getPayoutPreviewSummary,
  createPayout,
  getPayouts,
  getColocationPayments,
  getPayoutPayment,
  updatePayments,
  getSenderAndRecipient,
  getRoomAssignmentList,
  getRentReportList,
  getRentReportVersions,
  generateRentReports,
  getDiscussionThreadById,
  createDiscussionThreadMessage,
  createDiscussionThread,
  deleteDiscussionThreadMessage,
  updateContract,
  updateRoomAvailability,
  getRoomAssignment,
  getCityList,
  updateMoveIn,
  getBroadcastMessages,
  createBroadcastMessage,
  updateBroadcastMessage,
  deleteBroadcastMessage,
  archiveBroadcastMessage,
  setBroadcastMessageToActive,
  getColocations,
  getStatsDashboard,
  getContractsList,
} = colocAdminApi;
